"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment ProductListingHeader on EditorialHeader {\n    id\n    headline\n    headlineStorybookColor\n    extraLongHeadline\n    backgroundStorybookColor\n    imageUrl\n    text\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productListingHeaderFragment = void 0;
var _fetching = require("@ori/fetching");
const productListingHeaderFragment = exports.productListingHeaderFragment = (0, _fetching.gql)(_templateObject());
